export default {
  account: 'Διαχείριση λογαριασμού',
  adminComment: 'Σχόλιο για χρήστη',
  adminCommentInternal: 'Σχόλιο για άλλους διαχειριστές',
  adminResponseInfo: 'Απάντηση διαχειριστή',
  advancedStaffSearch: 'Σύνθετη αναζήτηση για προσωπικό',
  approve: 'Έγκριση',
  approved: 'Εγκρίθηκε',
  back: 'Επιστροφή',
  basicInfo: 'Βασικά στοιχεία',
  birthDate: 'Ημερομηνία γέννησης',
  birthDay: 'ΗΗ',
  birthMonth: 'ΜΜ',
  birthYear: 'ΕΕΕΕ',
  cardFilter: 'Κάρτα',
  cardID: 'Αριθμός κάρτας',
  cardOptions: {
    na: 'Με ή χωρίς κάρτα',
    any: 'Οποιαδήποτε κάρτα',
    one: 'Συγκεκριμένος αριθμός κάρτας'
  },
  certifiedUpdated:
    'Έχουν αλλάξει τα στοιχεία σας από την ΗΔΙΚΑ (από τις %{date})',
  change: 'Αλλαγή',
  citizenship: 'Υπηκοότητα',
  close: 'Κλείσιμο',
  comments: 'Σχόλια (Προαιρετικό)',
  confirm: {
    mail: 'Παρακαλώ, εισαγάγετε το PIN που λάβατε στο e-mail σας.',
    phone: 'Παρακαλώ, εισαγάγετε το PIN που λάβατε στο κινητό σας.',
    ssn: 'Παρακαλώ, εισαγάγετε τον ΑΜΚΑ σας',
    title: 'Επιβεβαίωση'
  },
  contactInfo: 'Στοιχεία επικοινωνίας',
  contractType: 'Είδος σύμβασης',
  copyright:
    '© 2017 Εθνική Βιβλιοθήκη της Ελλάδος. Με επιφύλαξη παντός δικαιώματος.',
  countrySsn: 'Χώρα ΑΜΚΑ',
  countryTin: 'Χώρα ΑΦΜ',
  data: 'Στοιχεία',
  dataChanged: 'Η αλλαγή πραγματοποιήθηκε',
  date: 'Ημερομηνία',
  dateRange: {
    from: 'Από',
    to: 'Μέχρι'
  },
  deactivation: 'Αίτηση απενεργοποίησης',
  desc:
    'Η υπηρεσία Διαχείρισης Λογαριασμού επιτρέπει στον χρήστη να αιτηθεί ρόλους, να ανατρέξει στις αιτήσεις που έχει κάνει και να διαχειριστεί τον κωδικό εισόδου',
  editManual: 'Επεξεργασία στοιχείων χειροκίνητα',
  error: {
    desc: 'Παρακαλώ, επικοινωνείστε με τους διαχειριστές της σελίδας.',
    existingTin:
      'Υπάρχει ήδη εγγεγραμμένος χρήστης με ΑΦΜ: %{tin} και στοιχεία λογαριασμού %{contact}',
    generic: 'Λυπούμαστε, υπήρξε κάποιο πρόβλημα!',
    gsis: 'Λυπούμαστε, υπήρξε κάποιο πρόβλημα με το TAXISnet!',
    ssnExists: 'Το ΑΜΚΑ που δηλώθηκε ανήκει ήδη σε χρήστη',
    ssnDoesNotExist: 'Το ΑΜΚΑ δεν υπάρχει στο εθνικό μητρώο ΑΜΚΑ',
    valueExists: 'Η τιμή που δόθηκε ήδη ανήκει ήδη σε κάποιο χρήστη',
    ssnTinMismatch: 'Το ΑΜΚΑ και το ΑΦΜ σας, δεν ταιριάζουν'
  },
  errorCode: 'Κωδικός σφάλματος',
  faq: 'Συχνές Ερωτήσεις - Απαντήσεις',
  fathername: 'Πατρώνυμο',
  firstname: 'Όνομα',
  forceRole: 'Προσθήκη ρόλου στον χρήστη',
  formData: 'Δεδομένα φόρμας',
  gender: {
    gender: 'Φύλο',
    male: 'Άνδρας',
    female: 'Γυναίκα',
    other: 'Άλλο'
  },
  gsisLogin: 'Διασύνδεση με TAXISnet',
  gsisLogout: 'Αποσύνδεση από TAXISnet',
  gsisLogoutDesc:
    'Αν επιθυμείτε να συνδεθείτε με διαφορετικό λογαριασμό στο TAXISnet, θα χρειαστεί να αποσυνδεθείτε και να επαναλάβετε τη διαδικασία αναβάθμισης από την αρχή',
  hasGreekTinWarning:
    'Προσοχή! Ο χρήστης φαίνεται να έχει ελληνικό ΑΦΜ στο εθνικό μητρώο ΑΜΚΑ',
  helpdeskComment: 'Σημείωση απο helpdesk',
  hideRoles: 'Απόκρυψη ρόλων χρήστη',
  idCountry: 'Χώρα έκδοσης εγγράφου ταυτοποίησης',
  idDateIssued: 'Ημερομηνία έκδοσης',
  idDoc: 'Έγγραφο ταυτοποίησης',
  idFilter: {
    all: 'Κανένα',
    birthPaper: 'Ληξιαρχική πράξη γέννησης',
    id: 'Ταυτότητα',
    militaryId: 'Στρατιωτική ταυτότητα',
    passport: 'Διαβατήριο'
  },
  identityInfo: 'Πληροφορίες ταυτότητας',
  idikaConflict: 'Σύγκρουση δεδομένων φόρμας με ΗΔΙΚΑ',
  idikaData: 'Δεδομένα από την ΗΔΙΚΑ',
  idNumber: 'Αριθμός εγγράφου ταυτοποίησης',
  idikaUpdate: 'Ενημέρωση στοιχείων από ΗΔΙΚΑ',
  info: 'Χρήσιμες πληροφορίες',
  internalPhone: 'Εσωτερικό τηλέφωνο',
  lang: {
    el: 'Ελληνικά – ΕΛ',
    en: 'English – EN'
  },
  lastname: 'Επώνυμο',
  login: 'Είσοδος',
  logoTitle: 'Μετάβαση στην αρχική σελίδα της Διαχείρισης Λογαριασμού',
  logout: 'Έξοδος',
  mail: 'E-mail',
  notice: 'Σημείωση',
  notificationSeen: 'Έλαβα γνώση',
  noRolesAvailable: 'Δεν υπάρχουν διαθέσιμοι ρόλοι για τον λογαριασμό σας',
  password: 'Διαχείριση κωδικών',
  pending: 'Σε εκκρεμότητα',
  phone: 'Κινητό',
  pin: 'PIN',
  position: 'Θέση ευθύνης',
  privacyPolicy: 'Πολιτική προστασίας προσωπικών δεδομένων',
  profile: 'Εμφάνιση προφίλ',
  registration: 'Εγγραφή',
  reject: 'Απόρριψη',
  rejected: 'Απορρίφθηκε',
  request: 'Αίτηση ενεργοποίησης',
  requestAdd: 'Αίτημα ενεργοποίησης',
  requestRemove: 'Αίτημα απενεργοποίησης',
  requestStatus: 'Κατάσταση Αίτησης',
  requestType: 'Τύπος αίτησης',
  requestedRole: 'Ρόλος αίτησης',
  requests: 'Αιτήσεις',
  requestsFilter: {
    all: 'Όλες οι αιτήσεις',
    approved: 'Αιτήσεις που έχουν εγκριθεί',
    completed: 'Αιτήσεις που έχουν ολοκληρωθεί',
    forced: 'Ρόλοι που έχουν προστεθεί από τον διαχειριστή',
    pending: 'Αιτήσεις που εκκρεμούν',
    rejected: 'Αιτήσεις που έχουν απορριφθεί'
  },
  respond: 'Διαχείριση αιτημάτων',
  response: 'Απάντηση στο αίτημα',
  resultsFound: 'Βρέθηκαν %{number} αποτελέσματα',
  resultsShown: 'Γίνεται προβολή %{number} αποτελεσμάτων',
  reviewer: 'Όνομα διαχειριστή',
  role: 'Ρόλος',
  roles: 'Ρόλοι',
  roleAdd: 'Προσθήκη ρόλου',
  rolesAll: 'Όλοι οι ρόλοι',
  roleRemove: 'Αφαίρεση ρόλου',
  search: 'Αναζήτηση',
  secondaryDataNote:
    'Τα εναλλακτικά στοιχεία επικοινωνίας που χρησιμοποιούνται για την ανάκληση κωδικού παραμένουν ως είχαν. Αν επιθυμείτε την αλλαγή και αυτών των στοιχείων παρακαλούμε επισκεφτείτε τη',
  selectCountry: 'Επιλογή χώρας',
  selectRole: 'Επιλογή ρόλου',
  showRequests: 'Αιτήσεις χρήστη',
  showRoles: 'Ρόλοι χρήστη',
  ssn: 'ΑΜΚΑ',
  submit: 'Καταχώρηση αλλαγών',
  submitRequest: 'Ολοκλήρωση αίτησης',
  subtitle: {
    data: 'Διαχείριση στοιχείων',
    requests: 'Διαχείριση αιτήσεων',
    roles: 'Διαχείριση ρόλων'
  },
  tin: 'ΑΦΜ',
  title: 'Εθνική Βιβλιοθήκη της Ελλάδος',
  type: 'Τύπος χρήστη',
  typeFilter: {
    all: 'Όλοι οι τύποι χρηστών',
    certified: 'Πιστοποιημένος χρήστης',
    staff: 'Προσωπικό',
    user: 'Απλός χρήστης',
    helpdesk: 'Πιστοποιημένος από helpdesk'
  },
  upgrade: {
    approved: 'Εγκρίθηκε',
    modified: 'Τροποποιήθηκε',
    pradoMismatch:
      'Τα δεδομένα εγγράφου ταυτοποίησης δεν συμφωνούν με την ΗΔΙΚΑ.',
    pradoOther:
      'Ο τύπος εγγράφου ταυτοποίησης που βρίσκεται ΗΔΙΚΑ δεν υποστηρίζεται.',
    pradoTypeMismatch:
      'Το έγγραφο ταυτοποίησης που δόθηκε για τον συγκεκριμένο ΑΜΚΑ (%{formDoc}) δεν συμφωνεί με αυτό της ΗΔΙΚΑ (%{idikaDoc}).',
    system: 'Σύστημα'
  },
  upgradeDesc:
    'Ο Πιστοποιημένος χρήστης απολαμβάνει το σύνολο των ηλεκτρονικών υπηρεσιών που προσφέρει η ΕΒΕ. Για την πιστοποίηση των στοιχείων (Όνομα, Επώνυμο, Πατρώνυμο, Ημ. Γεν) χρειάζεται η διασύνδεση της εφραρμογής με το Taxis.',
  upgradeManual: 'Αναβάθμιση σε Πιστοποιημένο χρήστη χειροκίνητα',
  upgradeUser: 'Αναβάθμιση σε Πιστοποιημένο χρήστη',
  usage: 'Οδηγίες χρήσης',
  userRequestInfo: 'Αίτημα χρήστη',
  users: 'Διαχείριση χρηστών',
  version: 'Εκδοση %{version}',
  versionBackend: '- %{version}',
  viewRequest: 'Προβολή αιτήματος',
  warning: 'Προσοχή'
}



// WEBPACK FOOTER //
// ./i18n/locale-el.js